module.exports = __webpack_public_path__ + "static/media/4-4.e56c177c.png";